import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SprintService {
  constructor(private api: ApiService) {}

  getAllSprints(data: any): Observable<any> {
    return this.api.post(environment.getAllSprints, data);
  }

  createSprint(data: any): Observable<any> {
    return this.api.post(environment.createSprint, data);
  }

  updateSprint(data: any): Observable<any> {
    return this.api.post(environment.updateSprint, data);
  }

  deleteSprint(data: any): Observable<any> {
    return this.api.post(environment.deleteSprint, data);
  }

  getSprintById(data: any): Observable<any> {
    return this.api.post(environment.getSprintById, data);
  }
}
